export default __webpack_public_path__ + "assets/images/aaaa24e99a81cce002bfdcb5fec4a494.svg";